// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bFIk","clinicsSelect":"styles_clinicsSelect__14G5F"};